import React from 'react';
import './FailPage.css';
import {MdOutlineClose} from "react-icons/md";
import {Button} from "./Button";
import {useTranslation} from '../i18n/LanguageProvider';
import {useSearchParams} from 'react-router-dom';

export const FailPage = () => {
    const {t} = useTranslation();
    const [searchParams] = useSearchParams();
    const isSuperlike = searchParams.get('productType') === 'superlike';
    return (
        <div className={'FailPage-container'}>
            <div className={'FailPage-header'}>
                <div className={'FailPage-cross'}>
                    <MdOutlineClose
                        color={'#9C4C3A'}
                        size={25}
                    />
                </div>
                <h1 className={'FailPage-title'}>
                    {t(isSuperlike ? 'fail.superlike.title' : 'fail.title')}
                </h1>
            </div>
            <span className={'FailPage-subtitle'}>
                {t('fail.subtitle')}
            </span>
            <Button
                onClick={() => window.location.replace('https://anonchat.com')}
                title={t('actions.goHome')}
            />
            <span className={'FailPage-subtitle-footer'}>
                {t('support.contactPrefix')}
                <a href={'https://anonchat.com/app'}>{t('support.anonchatLinkLabel')}</a>
                {t('support.contactMiddle')}
                <a href={'https://t.me/anonchatsupport'}>{t('support.telegramLinkLabel')}</a>
            </span>
        </div>
    );
};
